import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SpinInputClass;
function SpinInput() {
  if (SpinInputClass === VOID) {
    class $ {
      constructor(partyId, playerIds, pinIds) {
        this.l6r_1 = partyId;
        this.m6r_1 = playerIds;
        this.n6r_1 = pinIds;
      }
      toString() {
        return 'SpinInput(partyId=' + this.l6r_1.toString() + ', playerIds=' + toString(this.m6r_1) + ', pinIds=' + toString(this.n6r_1) + ')';
      }
      hashCode() {
        var result = this.l6r_1.hashCode();
        result = imul(result, 31) + hashCode(this.m6r_1) | 0;
        result = imul(result, 31) + hashCode(this.n6r_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SpinInput()))
          return false;
        if (!this.l6r_1.equals(other.l6r_1))
          return false;
        if (!equals(this.m6r_1, other.m6r_1))
          return false;
        if (!equals(this.n6r_1, other.n6r_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SpinInput');
    SpinInputClass = $;
  }
  return SpinInputClass;
}
//region block: exports
export {
  SpinInput as SpinInputg1yg8g6z8wv9,
};
//endregion

//# sourceMappingURL=SpinInput.mjs.map
